import type { IconSvgObject } from './types';

const ArrowLeft02Icon: IconSvgObject = [
  ["path", { d: "M11 18L5 12L11 6M5.5 12L19 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowLeft02Icon;
